// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IClaimPaymentMethodBreakdownDto
 */
export interface IClaimPaymentMethodBreakdownDto {
    /**
     * 
     * @type {string}
     * @memberof IClaimPaymentMethodBreakdownDto
     */
    category?: IClaimPaymentMethodBreakdownDtoCategoryEnum;
    /**
     * 
     * @type {string}
     * @memberof IClaimPaymentMethodBreakdownDto
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof IClaimPaymentMethodBreakdownDto
     */
    amount?: number;
    /**
     * 
     * @type {number}
     * @memberof IClaimPaymentMethodBreakdownDto
     */
    percentage?: number;
}

/**
* @export
* @enum {string}
*/
export enum IClaimPaymentMethodBreakdownDtoCategoryEnum {
    REIMBURSEMENT = 'REIMBURSEMENT',
    BILL_PAY = 'BILL_PAY',
    CARD = 'CARD',
    HEALTH_PLAN_REIMBURSEMENT = 'HEALTH_PLAN_REIMBURSEMENT',
    HEALTH_PLAN_BILL_PAY = 'HEALTH_PLAN_BILL_PAY',
    OTHER = 'OTHER'
}


/**
 * Check if a given object implements the IClaimPaymentMethodBreakdownDto interface.
 */
export function instanceOfIClaimPaymentMethodBreakdownDto(value: object): value is IClaimPaymentMethodBreakdownDto {
    return true;
}

export function IClaimPaymentMethodBreakdownDtoFromJSON(json: any): IClaimPaymentMethodBreakdownDto {
    return IClaimPaymentMethodBreakdownDtoFromJSONTyped(json, false);
}

export function IClaimPaymentMethodBreakdownDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IClaimPaymentMethodBreakdownDto {
    if (json == null) {
        return json;
    }
    return {
        
        'category': json['category'] == null ? undefined : json['category'],
        'description': json['description'] == null ? undefined : json['description'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'percentage': json['percentage'] == null ? undefined : json['percentage'],
    };
}

export function IClaimPaymentMethodBreakdownDtoToJSON(json: any): IClaimPaymentMethodBreakdownDto {
    return IClaimPaymentMethodBreakdownDtoToJSONTyped(json, false);
}

export function IClaimPaymentMethodBreakdownDtoToJSONTyped(value?: IClaimPaymentMethodBreakdownDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'category': value['category'],
        'description': value['description'],
        'amount': value['amount'],
        'percentage': value['percentage'],
    };
}

